export const useCategoryBlockPosts = (category: CategorySchema) => {
  const route = useRoute();

  const { categoryLockState, currentContent, mPageMedias } =
    inject(INJECT_CATEGORY_PAGE);

  const getPathForModal = (post: PostSchema) => {
    return `${route.path}#/modal/${category.slug}/${post.slug}`;
  };

  const getPathForVideo = (post: PostSchema) => {
    return `${route.path}#/video/${post.slug}`;
  };

  const getPathForLink = (post: PostSchema) => {
    if (route.params.eval) {
      return `/${Sections.ChildForYou}/eval/${route.params.eval}/${category.slug}/post/${post.slug}`;
    } else {
      return `/${route.params.section}/${currentContent.value.slug}/${category.slug}/post/${post.slug}`;
    }
  };

  const getFirstMedia = (post: PostSchema) => {
    if (
      post.medias &&
      post.medias.length &&
      mPageMedias.value.has(post.medias[0].id)
    ) {
      return mPageMedias.value.get(post.medias[0].id);
    }
    return null;
  };

  const posts = computed(() => {
    const items = category.posts ? [...category.posts] : [];
    return items.map((item) => {
      const icon = item.contentType === 'course_video' ? 'video' : 'course';
      const firstMedia = getFirstMedia(item);
      let thumbnailUrl: string;
      let videoUrl: string;
      let path;
      if (firstMedia && firstMedia.mime === 'application/pdf') {
        path = getPathForModal(item);
      } else if (firstMedia && firstMedia.mime === 'video/mp4') {
        path = getPathForVideo(item);
      } else {
        path = getPathForLink(item);
      }
      if (firstMedia && firstMedia.appThumbnailUrl) {
        thumbnailUrl = firstMedia.appThumbnailUrl;
      }
      if (firstMedia && firstMedia.mime === 'video/mp4') {
        videoUrl = firstMedia.url;
      }
      return {
        ...item,
        lockedContent: item.lockedContent || item.contentType,
        icon,
        path,
        thumbnailUrl,
        videoUrl,
      };
    });
  });

  return {
    isTypePostLocked: categoryLockState.value.isTypePostLocked,
    posts,
    currentContent,
  };
};
